import { render, staticRenderFns } from "./UsuariosSelectComponent.vue?vue&type=template&id=6546b67f&"
import script from "./UsuariosSelectComponent.vue?vue&type=script&lang=js&"
export * from "./UsuariosSelectComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports